<template>
	<v-app :style="cssVars" class="flex v-application " data-app>
		<v-dialog
			v-model="$store.state.loading"
			persistent
			fullscreen
			content-class="loading-dialog"
		>
			<v-container fill-height>
				<v-layout row justify-center align-center>
					<v-progress-circular
						indeterminate
						:size="70"
						:width="7"
						color="purple"
					></v-progress-circular>
				</v-layout>
			</v-container>
		</v-dialog>
		<v-main>
			<v-card height="100%" class="mx-auto overflow-hidden grey lighten-3">
				<v-app-bar>
					<v-app-bar-nav-icon
						color="white"
						v-if="$store.state.authenticated"
						@click="drawer = true"
					></v-app-bar-nav-icon>
					<v-toolbar-title
						>{{ $store.state.menu_option }} ({{
							$store.state.usuario.nombre
						}})</v-toolbar-title
					>

					<div class="row ma-0 mt-1 justify-content-end">
						<div
							class="col-xs-12 col-sm-10 col-md-12 offset-md-10 offset-sm-10 offset-xs-10"
						>
							<img
								class="ma-0 pa-0 ml-2 rounded-lg"
								height="55px"
								src="/img/Calo_logo.png"
							/>&nbsp;
						</div>
					</div>
				</v-app-bar>

				<v-navigation-drawer
					v-if="$store.state.authenticated"
					v-model="drawer"
					absolute
					temporary
					:width="320"
				>
					<v-list dense shaped>
						<template v-for="option in $store.state.menu">
							<v-list-group
								v-if="option.isMenu"
								:key="option.label"
								:prepend-icon="option.icono ? option.icono : 'account_circle'"
								:value="false"
								no-action
							>
								<template v-slot:activator>
									<v-list-item-content>
										<v-list-item-title>{{ option.label }}</v-list-item-title>
									</v-list-item-content>
								</template>

								<v-list-item
									v-for="subMenu in option.menu"
									:key="subMenu.label"
									@click="goTo(subMenu)"
								>
									<v-list-item-content>
										<v-list-item-title>{{ subMenu.label }}</v-list-item-title>
									</v-list-item-content>
									<v-list-item-icon>
										<v-icon>{{
											option.icono ? option.icono : 'account_circle'
										}}</v-icon>
									</v-list-item-icon>
								</v-list-item>
							</v-list-group>

							<v-list-item
								v-else
								:key="option.label"
								link
								:prepend-icon="option.icono ? option.icono : 'article'"
								@click="goTo(option)"
							>
								<v-list-item-icon>
									<v-icon>{{
										option.icono ? option.icono : 'exit_to_app'
									}}</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>{{ option.label }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>
					</v-list>
				</v-navigation-drawer>
				<v-container>
					<router-view />
				</v-container>
			</v-card>
		</v-main>
		<v-snackbar
			v-for="(snackbar, index) in snackbars.filter((s) => s.showing)"
			:key="snackbar.text + Math.random()"
			v-model="snackbar.showing"
			:color="snackbar.type"
			:timeout="3000"
			:style="`padding-bottom: ${index * 60}px;`"
		>
			{{ snackbar.text }}
		</v-snackbar>
		<confirm ref="confirm"></confirm>
	</v-app>
</template>

<script>
	import { mapState } from 'vuex';
	import Confirm from '../components/Confirm';
	export default {
		components: { Confirm },
		data() {
			return {
				drawer: false,
				isLoggedIn: null,
				name: null,
			};
		},
		mounted() {
			console.log(this.$vuetify);
			this.isLoggedIn = this.$store.state.token_session;
			this.name = 'Ruben';
			this.$root.$confirm = this.$refs.confirm.open;
		},
		computed: {
			...mapState(['snackbars']),
            cssVars() {
                const bgColor = process.env.VUE_APP_RP === 'Z333623510' ? '#3f992f' : '#0971d0';
                return {
                    '--primary-computed-color': bgColor,
                };
            },
		},
		methods: {
			cerrarSesion() {
				localStorage.token = null;
				this.$store.state.authenticated = false;
				this.$store.state.menu = [];
				this.$router.push({ name: 'login' });
			},
			goTo(option) {
				if (option.route && option.route.name == this.$route.name) {
					return;
				}
				if (option.route) {
					this.$router.push(option.route);
				} else if (option.action) {
					switch (option.action) {
						case 1:
							this.cerrarSesion();
							break;
					}
				}
			},
			hasPermission(permissions) {
				if (!permissions) return true;
				let typeUser = '' + this.$store.state.user.type;
				if (typeUser == '0' || permissions.includes(typeUser)) {
					return true;
				}
				return false;
			},
		},
	};
</script>
<style>
	body {
		font-family: Helvetica;
	}
	/* #3f992f verde */
	/* #0971D0 azul */
	/* #F4F4F4 beige */
	.v-app-bar {
		background-color: var(--primary-computed-color) !important;
		/* background-color: #3f992f !important; */
		border-color: var(--primary-computed-color) !important;
		/* border-color: #3f992f !important; */
		color: white !important;
		/* color: var(--primary-computed-color) !important; */
	}
	.loading-dialog {
		/* background-color: #3f992f; */
		background-color: var(--primary-computed-color);
	}
	.primaryButton {
		background-color: var(--primary-computed-color) !important;
		/* background-color: #3f992f !important; */
		border-color: var(--primary-computed-color) !important;
		/* border-color: #3f992f !important; */
		color: white !important;
	}

	/* ------------------------ */
	/* Estilos para las tablas */
	/* ------------------------ */
	tbody tr:nth-of-type(even) {
		background-color: rgba(0, 0, 0, 0.05);
	}
	.theme--light.v-data-table thead tr th {
		color: white;
	}

	/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type='number'] {
		-moz-appearance: textfield;
	}
</style>
